var map = {
	"./css/common.css": "erWL",
	"./css/font/RWmMoKWR9v4ksMfaWd_JN9XFiaQ.woff2": "OlEv",
	"./css/font/RWmMoKWR9v4ksMfaWd_JN9XLiaQ6DQ.woff2": "L0VX",
	"./css/vietnamese.css": "NN4m",
	"./fonts/Skia.ttf": "CUoa",
	"./fonts/woff2/PingFangSCBold.woff2": "IcgD",
	"./fonts/woff2/PingFangSCExtraLight.woff2": "YvnW",
	"./fonts/woff2/PingFangSCHeavy.woff2": "CqU5",
	"./fonts/woff2/PingFangSCLight.woff2": "oB5/",
	"./fonts/woff2/PingFangSCMedium.woff2": "0tga",
	"./fonts/woff2/PingFangSCRegular.woff2": "GKWp",
	"./fonts/woff2/Skia-Regular.woff2": "4O24",
	"./image/about/about-company.png": "L7kE",
	"./image/about/about.png": "EeLt",
	"./image/about/address.png": "cXt1",
	"./image/about/case-item.png": "Zuvu",
	"./image/about/coll-bg.png": "VInO",
	"./image/about/contact-bg.png": "MZlw",
	"./image/about/developmentBg.png": "Cl+H",
	"./image/about/email.png": "jelJ",
	"./image/about/inv.png": "pomf",
	"./image/about/logo.png": "7PyK",
	"./image/about/logo10.png": "ktKa",
	"./image/about/logo11.png": "4vEd",
	"./image/about/logo12.png": "Ro3H",
	"./image/about/logo13.png": "Epnq",
	"./image/about/logo14.png": "PeCU",
	"./image/about/logo15.png": "QPet",
	"./image/about/logo16.png": "p/Qn",
	"./image/about/logo17.png": "fefg",
	"./image/about/logo18.png": "g+ey",
	"./image/about/logo19.png": "ABIz",
	"./image/about/logo2.png": "NXXV",
	"./image/about/logo20.png": "oDdh",
	"./image/about/logo21.png": "Fi6+",
	"./image/about/logo22.png": "wcq+",
	"./image/about/logo23.png": "2Bc8",
	"./image/about/logo24.png": "7+f2",
	"./image/about/logo25.png": "b4Mi",
	"./image/about/logo26.png": "uxtb",
	"./image/about/logo3.png": "vdCK",
	"./image/about/logo4.png": "cRtg",
	"./image/about/logo5.png": "JWT8",
	"./image/about/logo6.png": "GqWu",
	"./image/about/logo7.png": "yjfA",
	"./image/about/logo8.png": "kT/r",
	"./image/about/logo9.png": "crVA",
	"./image/about/map-icon.png": "MQEk",
	"./image/about/partner.png": "iOmC",
	"./image/about/qua-bg.png": "qh8n",
	"./image/about/qua.png": "XuRw",
	"./image/about/school1.png": "36K/",
	"./image/about/stepBtn.png": "BlLM",
	"./image/about/stepBtnHover.png": "zANB",
	"./image/about/talent-bg.png": "fnoP",
	"./image/about/tel.png": "6648",
	"./image/beian.png": "X4ev",
	"./image/footer-address.png": "Ana6",
	"./image/footer-email.png": "39EG",
	"./image/footer-tel.png": "8p1i",
	"./image/header-mobile.png": "xCIh",
	"./image/header-x.png": "kuLD",
	"./image/index/astronaut1.png": "YPK1",
	"./image/index/astronaut2.png": "9/l4",
	"./image/index/bannerX.png": "r/ts",
	"./image/index/headerMenuX.png": "L9FM",
	"./image/index/index-new-bg.png": "rOkd",
	"./image/index/index-partner-bg.png": "MFgy",
	"./image/index/index-product-ap.png": "Out6",
	"./image/index/index-product-bg.png": "DZ4B",
	"./image/index/index-product-detail.png": "GJNA",
	"./image/index/index-product-guangwang.png": "dlaf",
	"./image/index/index-product-gw.png": "mrdb",
	"./image/index/index-product-platform.png": "RE1A",
	"./image/index/index-product-sj.png": "pc53",
	"./image/index/index-product-sw.png": "zfHr",
	"./image/index/index-product-system.png": "bqtu",
	"./image/index/index-solution-bg.png": "7QOj",
	"./image/index/index_about_us.png": "fiab",
	"./image/index/index_x1.png": "CKeq",
	"./image/index/logo.png": "gb2U",
	"./image/index/new.png": "jynK",
	"./image/index/new1.png": "noiG",
	"./image/index/pathIcon.png": "Hmza",
	"./image/index/product-operation.png": "TRPp",
	"./image/index/soluteImage1.jpg": "UAl+",
	"./image/index/soluteImage2.jpg": "M9w3",
	"./image/index/soluteImage3.jpg": "BnVk",
	"./image/index/solution-factory.png": "IwOT",
	"./image/index/solution-school.png": "vXEF",
	"./image/index/solution-wifi.png": "J7hS",
	"./image/index/wx-public.jpg": "rfQc",
	"./image/logo.png": "KItN",
	"./image/news/banbg.png": "Y0r6",
	"./image/news/jt_left.png": "L77I",
	"./image/news/jt_right.png": "mgeM",
	"./image/news/n1.png": "33HB",
	"./image/news/n10.jpg": "igNT",
	"./image/news/n2.png": "jFXA",
	"./image/news/n3.png": "oB5p",
	"./image/news/n5.png": "aBJb",
	"./image/news/n6.png": "KIcs",
	"./image/news/n7.jpg": "un0/",
	"./image/news/n8.jpg": "Hesl",
	"./image/news/n9.jpg": "Gs2+",
	"./image/news/new12.jpg": "j/i5",
	"./image/news/new13.jpg": "+beM",
	"./image/news/new14.jpg": "4Iay",
	"./image/news/new15.jpg": "OX1t",
	"./image/news/new16.jpg": "74Rw",
	"./image/news/new17.jpg": "PNCF",
	"./image/news/news-author.png": "keIC",
	"./image/news/news-back-list.png": "5y0V",
	"./image/news/news-title1.png": "Ddg/",
	"./image/news/news1.png": "fWeY",
	"./image/news/news11.jpg": "NOtL",
	"./image/news/news12.jpg": "6d5u",
	"./image/news/news2.png": "8tXV",
	"./image/news/news3.png": "X49C",
	"./image/news/news4.png": "Obj1",
	"./image/news/news5.png": "fWOU",
	"./image/news/timebg.png": "SGnu",
	"./image/partner/bannerBg.png": "QH6s",
	"./image/partner/case-byd.png": "mvXm",
	"./image/partner/case-fsk.png": "bXJc",
	"./image/partner/case-hs.jpg": "RIQi",
	"./image/partner/case-klgs.jpg": "LuSu",
	"./image/partner/case-lx.png": "8pkL",
	"./image/partner/case-rb.jpg": "28Uq",
	"./image/partner/case1.png": "I9rz",
	"./image/partner/case2.png": "7zAc",
	"./image/partner/case3.png": "uq4d",
	"./image/partner/case39.jpg": "r8Mc",
	"./image/partner/case4.png": "UFxB",
	"./image/partner/case40.jpg": "y44U",
	"./image/partner/case41.jpg": "84UU",
	"./image/partner/case5.png": "/ra0",
	"./image/partner/case6.png": "U/NO",
	"./image/partner/case7.png": "yPrz",
	"./image/partner/case8.png": "7Mfo",
	"./image/partner/case9.jpg": "atsX",
	"./image/partner/detail-type-checked.png": "b+ak",
	"./image/partner/detail-type.png": "Bkd4",
	"./image/partner/typeBg.png": "vGpk",
	"./image/product/detail/ap-detailList11.png": "2a09",
	"./image/product/detail/ap-detailList12.png": "Hdrk",
	"./image/product/detail/ap-detailList13.png": "Zz4W",
	"./image/product/detail/ap-detailList14.png": "7zX7",
	"./image/product/detail/ap-detailList15.png": "5CTe",
	"./image/product/detail/ap-detailList16.png": "zpSa",
	"./image/product/detail/detail-icon.png": "L7a6",
	"./image/product/detail/dzbpDetailList1.png": "i6W1",
	"./image/product/detail/dzxszDetailList1.png": "kp1N",
	"./image/product/detail/gap-detailList1.png": "tq5m",
	"./image/product/detail/gw-detailList1.png": "+GqC",
	"./image/product/detail/gw-detailList2.png": "xbUo",
	"./image/product/detail/gw-detailList3.jpg": "jTLd",
	"./image/product/detail/gw-detailList3.png": "elw8",
	"./image/product/detail/mdu-detailList11.png": "ZbSG",
	"./image/product/detail/mdu-detailList12.png": "hn5X",
	"./image/product/detail/olt-detailList11.png": "xLh5",
	"./image/product/detail/olt-detailList12.png": "QUU8",
	"./image/product/detail/olt-detailList13.png": "7ICh",
	"./image/product/detail/olt-detailList14.png": "48re",
	"./image/product/detail/rlmjDetailList1.png": "EkCk",
	"./image/product/detail/soft028.png": "kO2E",
	"./image/product/detail/soft10.png": "F8/j",
	"./image/product/detail/soft11.png": "4jBV",
	"./image/product/detail/soft12.png": "eUkM",
	"./image/product/detail/soft13.png": "W+L6",
	"./image/product/detail/soft14.png": "eLpu",
	"./image/product/detail/soft24.png": "xsxf",
	"./image/product/detail/soft25.png": "+RsV",
	"./image/product/detail/soft26.png": "LTz3",
	"./image/product/detail/soft27.png": "dgf3",
	"./image/product/detail/soft8.png": "71SW",
	"./image/product/detail/soft9.png": "3yg4",
	"./image/product/detail/sw-detailList11.png": "Hp5t",
	"./image/product/detail/sw-detailList12.png": "eY4p",
	"./image/product/detail/sw-detailList13.png": "Aov0",
	"./image/product/detail/sw-detailList14.png": "OmR1",
	"./image/product/detail/sw-detailList15.png": "BSa/",
	"./image/product/detail/sw-detailList16.png": "bChB",
	"./image/product/detail/xfjjDetailList1.png": "RkRA",
	"./image/product/detail/znhjDetailList1.png": "JXdE",
	"./image/product/detail/znsbDetailList1.png": "BwMM",
	"./image/product/icon-left.png": "AKIJ",
	"./image/product/icon/icon101.png": "4ycx",
	"./image/product/icon/icon1010.png": "8Jla",
	"./image/product/icon/icon102.png": "iSv5",
	"./image/product/icon/icon103.png": "Rv3z",
	"./image/product/icon/icon104.png": "BEhv",
	"./image/product/icon/icon105.png": "9MCl",
	"./image/product/icon/icon106.png": "x0Hz",
	"./image/product/icon/icon107.png": "GFIT",
	"./image/product/icon/icon108.png": "WDbc",
	"./image/product/icon/icon109.png": "wc3q",
	"./image/product/icon/icon111.png": "gfbG",
	"./image/product/icon/icon1110.png": "3IBD",
	"./image/product/icon/icon112.png": "WNZC",
	"./image/product/icon/icon113.png": "c/fo",
	"./image/product/icon/icon114.png": "Okj6",
	"./image/product/icon/icon115.png": "9JkX",
	"./image/product/icon/icon116.png": "l46v",
	"./image/product/icon/icon117.png": "vzaO",
	"./image/product/icon/icon118.png": "1ZPn",
	"./image/product/icon/icon119.png": "SCKo",
	"./image/product/icon/icon121.png": "HY9X",
	"./image/product/icon/icon122.png": "Be0B",
	"./image/product/icon/icon123.png": "OfbK",
	"./image/product/icon/icon124.png": "IUqn",
	"./image/product/icon/icon125.png": "mSP/",
	"./image/product/icon/icon126.png": "gyYY",
	"./image/product/icon/icon127.png": "s8WF",
	"./image/product/icon/icon128.png": "1ghg",
	"./image/product/icon/icon129.png": "Gnyl",
	"./image/product/icon/icon131.png": "Gz0K",
	"./image/product/icon/icon132.png": "JK0J",
	"./image/product/icon/icon133.png": "FN1g",
	"./image/product/icon/icon134.png": "wJQa",
	"./image/product/icon/icon135.png": "yqlb",
	"./image/product/icon/icon136.png": "gQM8",
	"./image/product/icon/icon137.png": "u51S",
	"./image/product/icon/icon138.png": "4EdI",
	"./image/product/icon/icon139.png": "qS38",
	"./image/product/icon/icon141.png": "U31V",
	"./image/product/icon/icon142.png": "6C9G",
	"./image/product/icon/icon143.png": "E+kW",
	"./image/product/icon/icon144.png": "88wO",
	"./image/product/icon/icon145.png": "sc7+",
	"./image/product/icon/icon146.png": "UN0E",
	"./image/product/icon/icon147.png": "uzdz",
	"./image/product/icon/icon148.png": "kE0b",
	"./image/product/icon/icon149.png": "kXn9",
	"./image/product/icon/icon241.png": "yx+J",
	"./image/product/icon/icon242.png": "geUC",
	"./image/product/icon/icon243.png": "moAJ",
	"./image/product/icon/icon244.png": "wkVH",
	"./image/product/icon/icon245.png": "cugX",
	"./image/product/icon/icon246.png": "ufy3",
	"./image/product/icon/icon247.png": "ksrf",
	"./image/product/icon/icon251.png": "Jpdi",
	"./image/product/icon/icon252.png": "B44Y",
	"./image/product/icon/icon253.png": "UAC7",
	"./image/product/icon/icon254.png": "tivz",
	"./image/product/icon/icon255.png": "YnC8",
	"./image/product/icon/icon261.png": "06sn",
	"./image/product/icon/icon262.png": "iETb",
	"./image/product/icon/icon263.png": "wh0c",
	"./image/product/icon/icon264.png": "nBOB",
	"./image/product/icon/icon265.png": "sVos",
	"./image/product/icon/icon266.png": "biCg",
	"./image/product/icon/icon267.png": "YFmu",
	"./image/product/icon/icon268.png": "jOXV",
	"./image/product/icon/icon271.png": "UfFm",
	"./image/product/icon/icon2710.png": "byeQ",
	"./image/product/icon/icon272.png": "cAm5",
	"./image/product/icon/icon273.png": "z0aU",
	"./image/product/icon/icon274.png": "2f6l",
	"./image/product/icon/icon275.png": "RP9t",
	"./image/product/icon/icon276.png": "CTuK",
	"./image/product/icon/icon277.png": "jCfF",
	"./image/product/icon/icon278.png": "3G6l",
	"./image/product/icon/icon279.png": "1C+R",
	"./image/product/icon/icon281.png": "PVRM",
	"./image/product/icon/icon2810.png": "gl5S",
	"./image/product/icon/icon2811.png": "fgei",
	"./image/product/icon/icon282.png": "fM2k",
	"./image/product/icon/icon283.png": "gdHh",
	"./image/product/icon/icon284.png": "WSFj",
	"./image/product/icon/icon285.png": "QDZ8",
	"./image/product/icon/icon286.png": "yGeH",
	"./image/product/icon/icon287.png": "yDgp",
	"./image/product/icon/icon288.png": "qGPe",
	"./image/product/icon/icon289.png": "dZIM",
	"./image/product/icon/icon81.png": "CeG9",
	"./image/product/icon/icon82.png": "zWCc",
	"./image/product/icon/icon83.png": "vFIA",
	"./image/product/icon/icon85.png": "JUf1",
	"./image/product/icon/icon86.png": "q8fe",
	"./image/product/icon/icon91.png": "exK+",
	"./image/product/icon/icon910.png": "LLoX",
	"./image/product/icon/icon92.png": "eyV2",
	"./image/product/icon/icon93.png": "vi8r",
	"./image/product/icon/icon94.png": "Ymy/",
	"./image/product/icon/icon95.png": "WQds",
	"./image/product/icon/icon96.png": "2Qob",
	"./image/product/icon/icon97.png": "IpTS",
	"./image/product/icon/icon98.png": "5fqP",
	"./image/product/icon/icon99.png": "RCkp",
	"./image/product/product-ap.png": "Jlu2",
	"./image/product/product-bg.png": "coB8",
	"./image/product/product-crm.png": "uqxK",
	"./image/product/product-dl.png": "Wrw3",
	"./image/product/product-dzbp.png": "Ag14",
	"./image/product/product-gap.png": "YO16",
	"./image/product/product-gw.png": "NnTH",
	"./image/product/product-item-bg.png": "ODJr",
	"./image/product/product-jfrz.png": "UjZj",
	"./image/product/product-jwzw.png": "HFrU",
	"./image/product/product-jxc.png": "qabr",
	"./image/product/product-kfxt.png": "g9Az",
	"./image/product/product-mdu.png": "ka5Z",
	"./image/product/product-odn.png": "citK",
	"./image/product/product-olt.png": "WPKH",
	"./image/product/product-qlbj.png": "Np0L",
	"./image/product/product-rlmj.png": "cLQX",
	"./image/product/product-shsd.png": "fdLW",
	"./image/product/product-shzn.png": "ae9+",
	"./image/product/product-sjxt.png": "7Oa7",
	"./image/product/product-sw.png": "Apcf",
	"./image/product/product-swgk.png": "X3xA",
	"./image/product/product-tdzj.png": "JUl8",
	"./image/product/product-wgxt.png": "ELey",
	"./image/product/product-xyaqxt.png": "+35Y",
	"./image/product/product-xysh.png": "gOSR",
	"./image/product/product-yyzt.png": "JWqp",
	"./image/product/product-zndj.png": "nIXj",
	"./image/product/product-znyy.png": "kEnJ",
	"./image/product/product-zzxy.png": "fY34",
	"./image/product/yygd.png": "C1sy",
	"./image/slide-code.png": "LZ8A",
	"./image/slide-customer.png": "rhk8",
	"./image/slide-lemon.png": "2CQ6",
	"./image/slide-mobile.png": "VUCk",
	"./image/slide-top.png": "VYTx",
	"./image/solution/detail-diffict3.png": "AGpS",
	"./image/solution/detail-diffict4.png": "XkpF",
	"./image/solution/detail-diffict5.png": "SnSu",
	"./image/solution/detail-diffict6.png": "DjjG",
	"./image/solution/detail-diffict7.png": "kS8X",
	"./image/solution/detail-diffict8.png": "aAdi",
	"./image/solution/detail-diffict9.png": "y2de",
	"./image/solution/detail-eight-bg.png": "DRhD",
	"./image/solution/detail-five-bg.png": "E2d/",
	"./image/solution/detail-four-bg.png": "Speh",
	"./image/solution/detail-list-bg.png": "ElFE",
	"./image/solution/detail-night-bg.png": "zSxh",
	"./image/solution/detail-one1.png": "C8gK",
	"./image/solution/detail-one2.png": "HZf1",
	"./image/solution/detail-one3.png": "kiJN",
	"./image/solution/detail-one4.png": "GT16",
	"./image/solution/detail-self1.png": "k9Id",
	"./image/solution/detail-self2.png": "XTSf",
	"./image/solution/detail-self3.png": "qGFV",
	"./image/solution/detail-self4.png": "4wRz",
	"./image/solution/detail-seven-bg.png": "84xO",
	"./image/solution/detail-six-bg.png": "es0w",
	"./image/solution/detail-three-bg.png": "dtqV",
	"./image/solution/detail-two-bg.png": "7mqa",
	"./image/solution/detail-two1.png": "tRsx",
	"./image/solution/detail.png": "eM8B",
	"./image/solution/factory_icon.png": "7gn1",
	"./image/solution/school_icon.png": "iRbf",
	"./image/solution/solution-bg.png": "iY6+",
	"./image/solution/solution-detail-bg.png": "YeZ/",
	"./image/solution/solution-factory.png": "Dc+d",
	"./image/solution/solution-four-more-hover.png": "9flE",
	"./image/solution/solution-four-more.png": "GDvX",
	"./image/solution/solution-gongdi.png": "jREi",
	"./image/solution/solution-more.png": "SGnU",
	"./image/solution/solution-school.png": "ni9L",
	"./image/solution/solution-smart-factory1.png": "a+Cg",
	"./image/solution/solution-smart-fatory.png": "bXMT",
	"./image/solution/solution-smart-school.png": "fXIA",
	"./image/solution/solution-smart-school1.png": "wwfN",
	"./image/solution/solution-value-eight1.png": "htuU",
	"./image/solution/solution-value-eight2.png": "83KI",
	"./image/solution/solution-value-eight3.png": "ZYZL",
	"./image/solution/solution-value-eight4.png": "wyc3",
	"./image/solution/solution-value-five1.png": "nfiZ",
	"./image/solution/solution-value-five2.png": "RoKO",
	"./image/solution/solution-value-five3.png": "SGah",
	"./image/solution/solution-value-five4.png": "VWCu",
	"./image/solution/solution-value-five5.png": "NalK",
	"./image/solution/solution-value-four1.png": "/s/v",
	"./image/solution/solution-value-four2.png": "jQdO",
	"./image/solution/solution-value-four3.png": "f2rC",
	"./image/solution/solution-value-night1.png": "mmmK",
	"./image/solution/solution-value-night2.png": "+fNF",
	"./image/solution/solution-value-night3.png": "+3eo",
	"./image/solution/solution-value-night4.png": "8My6",
	"./image/solution/solution-value-seven1.png": "evDn",
	"./image/solution/solution-value-seven2.png": "Z0wu",
	"./image/solution/solution-value-six3.png": "T1DL",
	"./image/solution/solution-value-three1.png": "vEQx",
	"./image/solution/solution-value-three2.png": "s2SQ",
	"./image/solution/solution-value-three3.png": "Qx2R",
	"./image/solution/solution-value-three4.png": "c9bi",
	"./image/solution/solution-value-three5.png": "/uH1",
	"./image/solution/solution-wx-zz.png": "ujEI",
	"./image/solution/value-bg.png": "nGCx",
	"./image/solution/wifi-icon.png": "qa66",
	"./image/test/circle1.png": "iKrq",
	"./image/test/circle2.png": "rfk/",
	"./image/xplan/analysisBg1.png": "R1PH",
	"./image/xplan/analysisText.png": "Gn1x",
	"./image/xplan/case1.png": "fcjf",
	"./image/xplan/case2.png": "IRkB",
	"./image/xplan/case3.png": "JVxh",
	"./image/xplan/case4.png": "WKm5",
	"./image/xplan/choose-bg.png": "S9H8",
	"./image/xplan/choose.png": "fqPT",
	"./image/xplan/feedbackBg.png": "roih",
	"./image/xplan/feedbackIcon1.png": "xCUg",
	"./image/xplan/first.png": "An45",
	"./image/xplan/money-first.png": "wTbc",
	"./image/xplan/money-second.png": "++r1",
	"./image/xplan/money-three.png": "uHx7",
	"./image/xplan/money.png": "z42X",
	"./image/xplan/money1.png": "IDky",
	"./image/xplan/money2.png": "AVtO",
	"./image/xplan/plus-icon1.png": "vt5K",
	"./image/xplan/plus-icon10.png": "o9qp",
	"./image/xplan/plus-icon11.png": "DZ6b",
	"./image/xplan/plus-icon2.png": "3fC0",
	"./image/xplan/plus-icon3.png": "USWr",
	"./image/xplan/plus-icon4.png": "NDTs",
	"./image/xplan/plus-icon5.png": "VwXe",
	"./image/xplan/plus-icon6.png": "Vzb5",
	"./image/xplan/plus-icon7.png": "piG+",
	"./image/xplan/plus-icon8.png": "4VT2",
	"./image/xplan/plus-icon9.png": "u2XE",
	"./image/xplan/step-bg.jpg": "7iPp",
	"./image/xplan/step-icon.png": "vcUC",
	"./image/xplan/step-icon1.png": "HPll",
	"./image/xplan/trusteeship-bg.png": "dhzd",
	"./image/xplan/trusteeship-con.png": "YPZP",
	"./image/xplan/trusteeship1.png": "qKx6",
	"./image/xplan/trusteeship2.png": "tcq+",
	"./image/xplan/trusteeship3.png": "HzBF",
	"./image/xplan/trusteeship4.png": "8SZy",
	"./image/xplan/trusteeship5.png": "iGAu",
	"./image/xplan/trusteeship6.png": "eerp",
	"./image/xplan/trusteeshipBg.png": "zE3p",
	"./image/xplan/trusteeshipText.png": "LkQ1",
	"./image/xplan/vip-bg1.png": "ku0U",
	"./image/xplan/vip-bg2.png": "QdJS",
	"./image/xplan/x-about-icon.png": "+kUr",
	"./image/xplan/x-about-icon1.png": "rSct",
	"./image/xplan/x-about-icon2.png": "/yVA",
	"./image/xplan/x-about-icon3.png": "C9y6",
	"./image/xplan/x-about-icon4.png": "u1SQ",
	"./image/xplan/x-about-icon5.png": "+FwQ",
	"./image/xplan/x-about-icon6.png": "HypC",
	"./image/xplan/x-cases.png": "HxBS",
	"./image/xplan/x-desc.png": "beT5",
	"./image/xplan/xPartner-bg.png": "7nDQ",
	"./image/xplan/xPartner1.png": "+GEe",
	"./image/xplan/xPartner2.png": "ph+1",
	"./image/xplan/xPartner3.png": "Z96X"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0